<template>
  <div>
    <div class="form-row text-left">
      <div class="col form-group">
        <label>Order By: </label>
        <div class="d-inline-block" style="width: auto">
          <select
            class="selectpicker form-control ml-2"
            style="display: initial; width: auto;"
            v-model="orderBy"
          >
            <option value="Status">
              Status
            </option>
            <option value="Application Due">
              Application Due
            </option>
            <option value="Title">
              Title
            </option>
            <option value="Organization">
              Organization
            </option>
          </select>
        </div>
      </div>
      <div class="col form-group">
        <label>Status: </label>
        <div class="d-inline-block" style="width: auto">
          <select
            class="selectpicker form-control ml-2"
            style="display: initial; width: auto;"
            multiple
            data-actions-box="true"
            data-selected-text-format="count"
            data-none-selected-text="All Statuses"
            v-model="statusFilter"
          >
            <option
              v-for="status in availableStatuses"
              :key="status.Grant_Application_Status_Id"
              v-bind:value="status.Grant_Application_Status_Id"
            >
              {{ status.Title }}
            </option>
          </select>
        </div>
      </div>
      <div class="col mt-2 form-check ml-3 text-center">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="showHidden"
          id="showHidden"
          v-on:change="resetGrants"
        />
        <label class="form-check-label" for="showHidden">
          Show Hidden Grants
        </label>
      </div>
      <div class="col text-right">
        <input
          v-model="searchKeyword"
          class="form-control"
          style="width: auto; display:initial;"
          placeholder="Search Keyword"
        />
      </div>
    </div>
    <div
      class="row text-left mb-2 mx-1"
      style="border-bottom-width: 2px; border-bottom-color:gray; border-bottom-style:solid;"
    >
      <div
        v-for="applicationStatus in availableStatuses"
        :key="applicationStatus.Grant_Application_Status_Id"
        class="col mb-2"
      >
        <div class="row">
          <div
            class="col-auto"
            v-bind:class="
              $getClassForGrantApplicationStatus(
                applicationStatus.Grant_Application_Status_Id
              )
            "
            style="width: 2rem; height: 1.25rem; border-radius: .25rem;"
          />
          <div class="col">
            <p class="small mb-0">
              {{ applicationStatus.Title }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="grantApplication in filterApplications(grantApplications)
        .slice()
        .sort(sortGrantApplications)"
      :key="grantApplication.Grant_Application_Id"
      class="card text-left mb-1"
      v-bind:id="grantApplication.Grant_Application_Id"
    >
      <div
        class="card-header"
        v-bind:class="
          $getClassForGrantApplicationStatus(
            grantApplication.Grant_Application_Status
              .Grant_Application_Status_Id
          )
        "
      >
        <h5
          class="btn-link pointer mb-0"
          v-on:click="$goToURL(grantApplication.Grant.URL)"
          style="float:left"
        >
          {{ grantApplication.Grant.Title }}
        </h5>
        <button
          v-if="
            grantApplication.Grant_Application_Status
              .Grant_Application_Status_Id < 3
          "
          v-on:click="remove(grantApplication)"
          class="btn btn-sm btn-outline-primary ml-2"
          style="float:right;"
        >
          Remove
        </button>
        <button
          v-if="
            grantApplication.Grant_Application_Status
              .Grant_Application_Status_Id > 3 && !grantApplication.Is_Hidden
          "
          v-on:click="hide(grantApplication)"
          class="btn btn-sm btn-outline-primary ml-2"
          style="float:right;"
        >
          Hide
        </button>
        <button
          v-if="
            grantApplication.Grant_Application_Status
              .Grant_Application_Status_Id > 3 && grantApplication.Is_Hidden
          "
          v-on:click="unhide(grantApplication)"
          class="btn btn-sm btn-outline-primary ml-2"
          style="float:right;"
        >
          Unhide
        </button>
        <h6 class="mb-0 mt-2" style="float:right">
          Application Due:
          {{ $displayDate(grantApplication.Grant.Application_Deadline) }}
        </h6>
      </div>
      <div class="card-body pb-2">
        <GrantBody v-bind:Grant="grantApplication.Grant" />
        <div class="row mt-4">
          <div class="col-auto">
            <label>Status: </label>
            <div class="d-inline-block" style="width: auto">
              <select
                class="selectpicker form-control ml-2"
                style="display: initial; width: auto;"
                data-actions-box="true"
                v-model="
                  grantApplication.Grant_Application_Status
                    .Grant_Application_Status_Id
                "
                v-on:change="
                  updateStatus(
                    grantApplication,
                    grantApplication.Grant_Application_Status
                      .Grant_Application_Status_Id
                  )
                "
              >
                <option
                  v-for="status in availableStatuses"
                  :key="status.Grant_Application_Status_Id"
                  v-bind:value="status.Grant_Application_Status_Id"
                >
                  {{ status.Title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-auto">
            <button
              class="btn btn-primary"
              v-on:click="$emit('selectedApplication', grantApplication)"
            >
              Manage Application
            </button>
          </div>
          <div
            v-if="
              grantApplication.Grant_Application_Status
                .Grant_Application_Status_Id == 4
            "
            class="col-auto"
          >
            <button
              class="btn btn-primary"
              v-on:click="$emit('thankYous', grantApplication)"
            >
              Thank You Letters
            </button>
          </div>
          <div class="col" />
          <div class="col-auto">
            <button
              class="btn btn-link"
              v-on:click="addreminder(grantApplication.Grant_Application_Id)"
            >
              Add Reminder
            </button>
          </div>
        </div>
      </div>
    </div>
    <ConfirmationModal
      @confirm="confirmed"
      @cancel="cancelled"
      v-bind:Id="'confirmationModal'"
      v-bind:Title="'Remove Grant'"
      v-bind:Description="removeDescription"
      v-bind:ConfirmText="'Remove'"
    />

    <ConfirmationModal
      @confirm="confirmHideApplication"
      @cancel="cancelHideApplication"
      Id="hideGrantModal"
      Title="Hide Grant"
      Description="Are you sure you want to hide this grant?"
      ConfirmText="Hide"
    />

    <ConfirmationModal
      @confirm="writeThankYous"
      @cancel="cancelThankYous"
      Id="thankYouModal"
      Title="Congratulations"
      Description="Congratulations on receiving this grant! Would you like to write thank you letters now?"
      ConfirmText="Write Thank You Letters"
      v-bind:PositiveConfirmation="true"
    />

    <GrantAppReminderModal
      v-bind:GrantApplicationId="grantApplicationIdForReminder"
      @createdGrantReminder="createdGrantReminder"
      IdString="MyGrantsList"
    />
  </div>
</template>

<script>
import GrantBody from "@/components/GrantBody.vue";
import ConfirmationModal from "@/modals/ConfirmationModal.vue";
import GrantAppReminderModal from "@/modals/GrantAppReminderModal.vue";
import $ from "jquery";

export default {
  name: "MyGrantsList",
  components: {
    GrantBody,
    ConfirmationModal,
    GrantAppReminderModal
  },
  data() {
    return {
      grantApplications: [],
      grantApplicationToRemove: null,
      grantApplicationIdForReminder: "-1",
      removeDescription:
        "Are you sure you want to remove this from Saved Grants? This will remove all reminders related to this grant.",
      availableStatuses: [],
      grantApplicationForThankYous: null,
      grantApplicationToHide: null,
      showHidden: false,
      statusFilter: [],
      searchKeyword: "",
      orderBy: "Status"
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      await view
        .$getGrantApplicationsForUser(false)
        .then(grantApplications => {
          view.grantApplications = grantApplications.sort(view.orderByStatus);
        })
        .then(() => {
          view
            .$getGrantApplicationStatuses()
            .then(statuses => {
              view.availableStatuses = statuses;
            })
            .then(() => {
              $(".selectpicker").selectpicker("refresh");
              if (view.$route.params.id) {
                var elmnt = document.getElementById(view.$route.params.id);
                elmnt.scrollIntoView({
                  behavior: "smooth",
                  block: "center"
                });
              }
            });
          view.$store.commit("updateLoading", false);
        });
    } catch (error) {
      console.log(error);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    async resetGrants() {
      var view = this;
      view.$store.commit("updateLoading", true);
      await view
        .$getGrantApplicationsForUser(this.showHidden)
        .then(grantApplications => {
          view.grantApplications = grantApplications.sort(view.orderByStatus);
        })
        .then(() => {
          view
            .$getGrantApplicationStatuses()
            .then(statuses => {
              view.availableStatuses = statuses;
            })
            .then(() => {
              $(".selectpicker").selectpicker("refresh");
              view.$store.commit("updateLoading", false);
            });
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    remove(grantApplication) {
      this.grantApplicationToRemove = grantApplication;
      $("#confirmationModal").modal("show");
    },
    cancelled() {
      this.grantApplicationIdToRemove = -1;
      this.grantIdToRemove = -1;
    },
    async confirmed() {
      await this.removeGrant(this.grantApplicationToRemove);
    },
    async removeGrant(grantApplicationToRemove) {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        await view.$removeGrantApplication(grantApplicationToRemove);
        //remove the saved grant from the local saved grants list
        var viewDeletedIndex = view.grantApplications.findIndex(
          g =>
            g.Grant_Application_Id ==
            grantApplicationToRemove.Grant_Application_Id
        );
        view.grantApplications.splice(viewDeletedIndex, 1);
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$store.commit("updateLoading", false);
    },
    hide(grantApplication) {
      this.grantApplicationToHide = grantApplication;
      $("#hideGrantModal").modal("show");
    },
    async confirmHideApplication() {
      var view = this;
      await view.$hideGrantApplication(view.grantApplicationToHide).then(() => {
        if (!view.showHidden) {
          var viewDeletedIndex = view.grantApplications.findIndex(
            g =>
              g.Grant_Application_Id ==
              view.grantApplicationToHide.Grant_Application_Id
          );
          view.grantApplications.splice(viewDeletedIndex, 1);
        } else {
          view.grantApplicationToHide.Is_Hidden = true;
        }
        view.grantApplicationToHide = null;
      });
    },
    cancelHideApplication() {
      this.grantApplicationToHide = null;
    },
    async unhide(grantApplication) {
      var view = this;
      await view.$unhideGrantApplication(grantApplication).then(() => {
        grantApplication.Is_Hidden = false;
      });
    },
    filterApplications() {
      var applicationsToShow = [];
      var lowerKeyword = this.searchKeyword.toLowerCase();
      if (this.statusFilter.length > 0 && this.searchKeyword != "") {
        this.grantApplications.forEach(application => {
          if (
            this.statusFilter.includes(
              application.Grant_Application_Status.Grant_Application_Status_Id
            ) &&
            (application.Grant.Title.toLowerCase().includes(lowerKeyword) ||
              application.Grant.Description.toLowerCase().includes(
                lowerKeyword
              ) ||
              application.Grant.Organization.toLowerCase().includes(
                this.lowerKeyword
              ))
          )
            applicationsToShow.push(application);
        });
      } else if (this.statusFilter.length > 0) {
        this.grantApplications.forEach(application => {
          if (
            this.statusFilter.includes(
              application.Grant_Application_Status.Grant_Application_Status_Id
            )
          )
            applicationsToShow.push(application);
        });
      } else if (this.searchKeyword != "") {
        this.grantApplications.forEach(application => {
          if (
            application.Grant.Title.toLowerCase().includes(lowerKeyword) ||
            application.Grant.Description.toLowerCase().includes(
              lowerKeyword
            ) ||
            application.Grant.Organization.toLowerCase().includes(lowerKeyword)
          )
            applicationsToShow.push(application);
        });
      } else {
        applicationsToShow = this.grantApplications;
      }

      return applicationsToShow;
    },
    sortGrantApplications(a, b) {
      var orderA = null;
      var orderB = null;
      switch (this.orderBy) {
        case "Status":
          orderA = a.Grant_Application_Status.Grant_Application_Status_Id;
          orderB = b.Grant_Application_Status.Grant_Application_Status_Id;
          break;
        case "Application Due":
          orderA = a.Grant.Application_Deadline;
          orderB = b.Grant.Application_Deadline;
          break;
        case "Title":
          orderA = a.Grant.Title.toLowerCase();
          orderB = b.Grant.Title.toLowerCase();
          break;
        case "Organization":
          orderA = a.Grant.Organization.toLowerCase();
          orderB = b.Grant.Organization.toLowerCase();
          break;
      }
      return orderA < orderB ? -1 : orderA > orderB ? 1 : 0;
    },
    async updateStatus(grantApplication, newStatusId) {
      var view = this;
      view.$store.commit("updateLoading", true);
      try {
        var updatedGrant = await view.$updateGrantApplicationStatus(
          grantApplication,
          newStatusId
        );
        var updatedIndex = view.grantApplications.findIndex(
          g => g.Grant_Application_Id == grantApplication.Grant_Application_Id
        );
        view.$set(view.grantApplications, updatedIndex, updatedGrant);
        if (newStatusId == 4) {
          view.grantApplicationForThankYous = updatedGrant;
          $("#thankYouModal").modal("show");
        }
      } catch (e) {
        console.log(e);
        view.$store.commit("updateLoading", false);
      }
      view.$store.commit("updateLoading", false);
    },
    orderByStatus(a, b) {
      if (
        a.Grant_Application_Status.Grant_Application_Status_Id <
        b.Grant_Application_Status.Grant_Application_Status_Id
      ) {
        return -1;
      } else if (
        a.Grant_Application_Status.Grant_Application_Status_Id >
        b.Grant_Application_Status.Grant_Application_Status_Id
      ) {
        return 1;
      }
      return 0;
    },
    addreminder(grantApplicationId) {
      this.grantApplicationIdForReminder = grantApplicationId;
      $("#grantAppReminderModalMyGrantsList").modal("show");
    },
    createdGrantReminder() {
      this.grantApplicationIdForReminder = "-1";
      this.$showSnackbar("The reminder was added to your calendar.", true);
    },
    writeThankYous() {
      this.$emit("thankYous", this.grantApplicationForThankYous);
    },
    cancelThankYous() {
      this.grantApplicationForThankYous = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
